// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"cd19898b","194":"29ea017d","741":"fbdf578e","824":"6b587c35","845":"01bfed8e","950":"82ea04f2"}[chunkId] + ".chunk.js";
};